import axios from "../../apis/Api";
import history, { logout } from "../../history";
import { GET_ONE_1BILL_MANNUAL_SETTLEMENT_REPORT, GET_SHOP_ORDER_TRANSACTION_DETAIL_BY_PSID, GET_SHOP_ORDER_TRANSACTION_DETAIL_BY_ID } from "../../Types";
import { toast } from "react-toastify";
import { showLoading, hideLoading } from "react-redux-loading-bar";

export const getOneBillTransactionsForSettlement = (postedData) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .post(`api/OneBill/GetOneBillTransactionsForSettlement`, postedData)
    .then(({ data }) => {
      dispatch({
        type: GET_ONE_1BILL_MANNUAL_SETTLEMENT_REPORT,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};


export const getShopOrderTransactionDetailByPsid = (psid) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .get(`api/ShopOrderTransaction/GetShopOrderTransactionDetailByPsid?psid=`+psid)
    .then(({ data }) => {
      if(data.response == null)
      {
        toast.error("No unpaid 1-Bill transactions were found.");
      }
      dispatch({
        type: GET_SHOP_ORDER_TRANSACTION_DETAIL_BY_PSID,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};

export const getShopOrderTransactionDetailById = (id) => async (dispatch) => {
  dispatch(showLoading());
  await axios
    .get(`api/ShopOrderTransaction/GetShopOrderTransactionDetailById?id=`+id)
    .then(({ data }) => {
      dispatch({
        type: GET_SHOP_ORDER_TRANSACTION_DETAIL_BY_ID,
        payload: data.response,
      });
      dispatch(hideLoading());
    })
    .catch(function (error) {
      dispatch(hideLoading());
      if (error.response) {
        if (error.response.status === 401) {
          logout();
          history.push("/login");
          history.go("/login");
        } else if (
          error.response.status === 400 &&
          error.response.data.errors
        ) {
          let errorMessage = "";
          var errors = error.response.data.errors;
          var keys = Object.keys(errors);
          for (let j = 0; j < keys.length; j++) {
            errorMessage += errors[keys[j]] + " , \n";
          }
          toast.error(errorMessage);
        } else if (error.response.data)
          toast.error(
            error.response.data.Message
              ? error.response.data.Message
              : error.response.data.message
          );
        else {
          toast.error("Error while processing the request");
        }
      } else toast.error("Error while processing the request");
    });
};


export const oneBillManualSettlement = (postedData) => async (dispatch) => {
    dispatch(showLoading())
    await axios
        .post(`api/OneBill/OneBillManualSettlement`, postedData)
        .then(({ data }) => {
            toast.success("Posted successfully");
            dispatch(hideLoading())
        })
        .catch(function (error) {
            dispatch(hideLoading())
            if (error.response) {
                if (error.response.status === 401) {
                    logout()
                    history.push('/login')
                    history.go('/login')
                } else if (
                    error.response.status === 400 &&
                    error.response.data.errors
                ) {
                    let errorMessage = ''
                    var errors = error.response.data.errors
                    var keys = Object.keys(errors)
                    for (let j = 0; j < keys.length; j++) {
                        errorMessage += errors[keys[j]] + ' , \n'
                    }
                    toast.error(errorMessage)
                } else if (error.response.data)
                    toast.error(
                        error.response.data.Message
                            ? error.response.data.Message
                            : error.response.data.message
                    )
                else {
                    toast.error('Error while processing the request')
                }
            } else toast.error('Error while processing the request')
        })
}